module.exports = __webpack_public_path__ + "img/40_69_002_820.10f89af2.jpg";